import Repository from "./Repository";
import { CreateCourseCategory, UpdateCourseCategory } from "./schema/Course.schema";
import { API, graphqlOperation, GraphQLResult } from "@aws-amplify/api";

class CourseRepository extends Repository {
  async fetchCategories(shopId: string) {
    // const message = this.buildMessage({ shopId });
    try {
      const result = await this.apiGet({
        apiName: this.API_DASHBOARD_API,
        path: `/course/categories/${shopId}`,
        // message,
      });
      return result.courseCategories;
    } catch (error) {
      console.warn("error", error);
      return { error };
    }
  }

  async createCourseCategory(param: any) {
    try {
      const data: GraphQLResult<any> = await API.graphql(
        graphqlOperation(CreateCourseCategory, { input: param })
      );
      return data.data?.createCourseCategory;
    } catch (error) {
      console.warn("error", error);
      return { error };
    }
  }

  async updateCourseCategory(param: any) {
    try {
      const data: GraphQLResult<any>  = await API.graphql(
        graphqlOperation(UpdateCourseCategory, { input: param })
      );
      return data.data?.updateCourseCategory;
    } catch (error) {
      console.warn("error", error);
      return { error };
    }
  }
}

export default new CourseRepository();
